@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 font-medium">
            {{ field.label | localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          @if (!field.browserOpts.inLineWithCaption) {
            <mat-label>{{ field.label | localize }}</mat-label>
          }
          <mat-select [formControl]="field.control" [placeholder]="field.placeholder | localize"
            [multiple]="field.multiple" [required]="field.required">
            @if (field.search) {
              <div class="sticky -top-2 z-10 bg-white dark:bg-slate-800">
                <mat-form-field class="w-1/3 ml-4 mt-2 fuse-mat-emphasized-affix fuse-mat-rounded fuse-mat-dense">
                  <mat-icon matPrefix [svgIcon]="'mat_outline:search'"></mat-icon>
                  <input matInput [formControl]="filterControl" type="text" placeholder="{{ 'optionsSearch' | transloco }}">
                </mat-form-field>
              </div>
            }
            @if (!field.multiple) {
              <mat-option [value]="''">{{ 'noSelection' | transloco }}</mat-option>
            }
            @for (gr of filteredGroups | async; track gr) {
              <mat-optgroup [label]="gr.value" [class.hidden]="gr.hide">
                @for (opt of gr.option; track opt) {
                  <mat-option [value]="opt.code" [class.hidden]="opt.hide" [disabled]="opt.disabled || opt._deprecated">
                    {{ opt.value | localize }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
          @if (field.hint) {
            <mat-hint>{{ field.hint | localize }}</mat-hint>
          }
          @if (!field.readonly) {
            <mat-error>
              @if (field.control.hasError('required')) {
                {{ 'errorRequiredField' | transloco }}
              }
              @if (field.control.hasError('maxselect')) {
                {{ 'errorMaxSelectField' | transloco:{ maxSelect: field.control.errors.maxselect.max } }}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
} @else {
  {{ displayedValue }}
}

